module.exports = __webpack_public_path__ + "static/img/swiperadmin6.b774f21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/swiperadmin6.png
// module id = kKh5
// module chunks = 1